import React, { useState, useEffect } from 'react';
import axios from 'axios';

const HomeIngredient = ({ uId }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [totalRows, setTotalRose] = useState(0);
  const totalPages = Math.ceil(totalRows / itemsPerPage);
  const handleClick = (type) => {
    if (type === 'prev') {
      setCurrentPage(currentPage === 1 ? 1 : currentPage - 1);
    } else if (type === 'next') {
      setCurrentPage(currentPage === totalPages ? totalPages : currentPage + 1);
    } else {
      setCurrentPage(type);
    }
  };
  const [ingredients, setIngredients] = useState([]);

const getLowStock = async () => {
  const userData = JSON.parse(sessionStorage.getItem("userData"));

  if (!userData || !userData.id) {
    alert("User not found");
    return;
  }

  const userId = userData.id;
  const machineId = userData.selectedMachineIds;

  try {
    const res = await axios.get(
      `/api/low-stock/${userId}/${machineId}`,
      {
        withCredentials: true // 🔥 required if using cookies
      }
    );

    // console.log("Low Stock Data:", res.data);

    // 🔹 Save in state
    // setLowStockData(res.data.data);
      setIngredients(res.data.data);
      setTotalRose(res.data.count);

  } catch (err) {
    console.error(err.response?.data || err.message);
  }
};

  useEffect(() => {
    // fetchIngredients();
    getLowStock();
  }, [uId]);

  const [smallMedia, setSmallMedia] = useState(window.innerWidth <= 768); // Adjust breakpoint as needed
  useEffect(() => {
    const handleResize = () => {
      setSmallMedia(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [userD, setUserD] = useState(null);
  const [macId, setMacId] = useState(null);

  useEffect(() => {
    const userDataString = sessionStorage.getItem('userData');
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserD(userData);
    }
  }, []);

  useEffect(() => {
    if (userD) {
      const machineIds = userD.selectedMachineIds ? userD.selectedMachineIds.join(',') : null;
      setMacId(machineIds);
    }
  }, [userD]);


  // ✅ Calculate current visible rows
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, ingredients.length);
  const currentRows = ingredients.slice(startIndex, endIndex); // You can use this anywhere in your component
  
  const getVisiblePages = () => {
  if (totalPages <= 3) {
    return [...Array(totalPages)].map((_, i) => i + 1);
  }

  if (currentPage === 1) {
    return [1, 2, 3];
  }

  if (currentPage === totalPages) {
    return [totalPages - 2, totalPages - 1, totalPages];
  }

  return [currentPage - 1, currentPage, currentPage + 1];
};
    
  const renderTableRows = () => {
    const rows = [];

    for (let i = startIndex; i < endIndex; i++) {
      rows.push(
        <tr key={i} className={`cl-ingre ${smallMedia ? "cl-ingre2" : ""}`}>
          <td><div className="cell-content">{ingredients[i].name}</div></td>
          <td><div className="cell-content">{ingredients[i].stock}</div></td>
        </tr>
      );
    }

    return rows;
  };
  useEffect(() => {

    const interval = setInterval(() => {
      // fetchIngredients();
      getLowStock();
    }, 300000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);
  return (
    <div className={`homeIngre ${smallMedia ? "homeIngre2" : ""}`}>
      <div className={`${smallMedia ? "stock-hh" : "stock-hh2"}`}>
        <div className={`${smallMedia ? "" : "custom-h"}`}>Low Stock Ingredients</div>
      </div>
      <div className='tb2' style={{ height: currentRows < 10 ? `${currentRows * 7 + '%'}` : '' }}>
        <table className="customTable ingCl-tbl" style={{ borderCollapse: 'collapse', tableLayout: "fixed" }}>
          <thead className="tb-head">
            <tr className={`cl-ingre ${smallMedia ? "cl-ingre2" : ""}`}>
              <th className='cell-content'>Name</th>
              <th className='cell-content'>Stock</th>
            </tr>
          </thead>
          <tbody>{renderTableRows()}</tbody>
        </table>
      </div>
      <div className='bottomIngre sp-tbl-btm-ingre'>
        <div className='tb2-btm-lft' style={{ width: '25%'}}>
          <div className={`st-show ${smallMedia ? "st-show2" : ""}`}>
            <p className="onscreen">Showing {Math.min(((currentPage - 1) * itemsPerPage) + 1, totalRows)} to {Math.min(currentPage * itemsPerPage, totalRows)}</p>
            <p className="total">(Total {totalRows} entries)</p>
          </div>
        </div>
        {/* <div className='ordr-btn'> */}
          <button
          style={{marginBottom: '2px'}} 
          onClick={() => window.open("https://cocktailsupreme.com/?country=GB&shop_sign_in=true")}
          className={`editconst shop-btn  ${smallMedia ? "editconst2" : "favconst dup-btn"}`}>
            <div className='triangle-container-idbnt'>
              <div className='shadeTriangle-idbnt'></div>
            </div>
            <div className="btnName">
             Shop Now
            </div>
          </button>
        {/* </div> */}
        <div
          className={`h-pagenation ${smallMedia ? "h-pagenation2" : ""}`}
          style={{ width: "40%", margin: '0' }}
        >
          <button
            onClick={() => handleClick("prev")}
            disabled={currentPage === 1}
            className="constbtn"
          >
            Previous
          </button>

          {getVisiblePages().map((page) => (
            <button
              key={page}
              onClick={() => handleClick(page)}
              className={`pbtn ${
                currentPage === page ? "active12a2a" : ""
              }`}
            >
              {page}
            </button>
          ))}

          <button
            onClick={() => handleClick("next")}
            disabled={currentPage === totalPages}
            className="constbtn"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomeIngredient;
